@if (!hideHeader) {
  <header
    [ngClass]="{ 'header-height-outer': isLongHeader, 'header-bg': !isOrangeHeader, 'mb-5 mb-lg-6': withBottomMargin }"
    class="bg-primary"
  >
    <div
      [ngClass]="{ 'container-wide': wideHeader, limited: !wideHeader, 'not-md-limited': !wideHeader }"
      class="container header-height-inner"
    >
      <ng-content />
      @if (title && isLongHeader) {
        <div class="mt-md-8 mt-sm-4 pt-5">
          <h1 [translate]="title" class="text-white"></h1>
        </div>
      }
    </div>
  </header>
}
